import React, { useState } from "react";
import { ButtonTypes } from "../../../../../../../../components/ui/Button";
import I18n from "../../../../../../../../core/localization/I18n";
import { UiActionRenderers } from "../../../../../../../../core/uiAction/IUiAction";
import { StakeholderType } from "../../../../../../../../enums";
import ActionsApi from "../../../../../../../../services/api/v2/actions/Actions.api";
import { SingleFormModel } from "../../../../../../../change/forms/singleFormModel/SingleForm_model";
import { SingleForm } from "../../../../../../../change/forms/singleFormModel/SingleForm_view";
import { getStakeholderFormFields } from "./getStakeholderFormFields";

interface AddStakeholderFormProps {
  organisationId: number;
  projectId: number;
  actionId: number;
  stakeholderType: StakeholderType;
  setIsActive: (e?) => void;
  reloadImpactFn: (id: number) => void;
}

export const AddStakeholderForm: React.FC<AddStakeholderFormProps> = ({
  reloadImpactFn,
  setIsActive,
  organisationId,
  projectId,
  actionId,
  stakeholderType
}) => {
  const [model] = useState(
    () => new AddStakeholderFormModel(reloadImpactFn, setIsActive, projectId, actionId, organisationId, stakeholderType)
  );

  return (
    <div className="mt-2">
      <SingleForm model={model.formModel} />
    </div>
  );
};

export class AddStakeholderFormModel {
  formModel: SingleFormModel;

  /**
   *
   */
  constructor(
    reloadImpactFn: (id: number) => void,
    setIsActive: (e?) => void,
    projectId,
    actionId,
    organisationId,
    stakeholderType
  ) {
    const actionsProvider = ActionsApi;
    this.formModel = new SingleFormModel();
    this.formModel.formFields = getStakeholderFormFields(
      actionsProvider,
      projectId,
      actionId,
      organisationId,
      stakeholderType
    );
    this.formModel.actions = [
      {
        id: "action1",
        label: I18n.t("phrases.cancel"),
        onAction: ev => {
          setIsActive(false);
        },
        componentProps: {
          type: ButtonTypes.LINK,
          className: "ml-auto"
        },
        rendersIn: UiActionRenderers.BUTTON
      },
      {
        id: "action2",
        label: I18n.t("phrases.save"),
        onAction: async ev => {
          let res = await this.formModel.submit();
          if (!res) return;
          await actionsProvider.assignStakeholderOwners(organisationId, projectId, [actionId], res.stakeholders);
          reloadImpactFn(actionId);
        },
        componentProps: {
          className: "ml-2"
        },
        rendersIn: UiActionRenderers.BUTTON
      }
    ];
  }
}
